import { useGetCreatorDataQuery } from "../redux/reduxAPI";
import { useGetCreatorConfigQuery } from "../redux/efficientReduxAPI";
import { useAuthStore } from "stores/auth.store";

export const useGetCreatorDataWithCreatorIdQuery = () => {
  const { isLoggedIn } = useAuthStore();
  const { data: dataCreatorConfig } = useGetCreatorConfigQuery(undefined, {
    skip: !isLoggedIn,
  });
  const result = useGetCreatorDataQuery(
    {
      creatorId: dataCreatorConfig?.creator_id,
    },
    {
      skip: !dataCreatorConfig?.creator_id,
    }
  );
  return result;
};
